import { EmptyArray } from 'lib/array/arrayUtils'
import { createSelector } from 'reselect'
import getIsCheckoutLoyaltyInternationalTrip from './getIsCheckoutLoyaltyInternationalTrip'
import getIsCurrentRegionUserLoyaltyRegion from 'loyalty/selectors/getIsCurrentRegionUserLoyaltyRegion'
import { findPostPurchaseCheckout } from 'lib/checkout/checkoutUtils'
import getIsTasteOfGoldEligibleCheckout from './getIsTasteOfGoldEligibleCheckout'
import getCheckoutLoyaltyEligibleTransferOptions from './getCheckoutLoyaltyEligibleTransferOptions'
import { getHasBothTransferDirectionsBundled } from 'checkout/selectors/experienceSelectors'
import { hasConfiguredHomeToAirportOption } from 'loyalty/lib/transferOfferUtils'
import { canUseAirportTransferBenefit } from 'loyalty/lib/airportTransferBenefitUtils'
import { hasLoyaltyBenefitEligibleTravelCheckoutItems } from 'loyalty/lib/isLoyaltyBenefitEligibleTravel'

const getCanRedeemTransferLoyaltyBenefit = createSelector(
  (state: App.State) => state.loyalty.account.data?.benefits,
  (state: App.State) => state.loyalty.account.data?.tier,
  (state: App.State) => state.loyalty.config,
  (state: App.State) => getIsCheckoutLoyaltyInternationalTrip(state),
  (state: App.State) => state.loyalty.config?.transferAirports,
  (state: App.State) => getIsCurrentRegionUserLoyaltyRegion(state),
  (state: App.State) => findPostPurchaseCheckout(state.checkout.cart.mode),
  (state: App.State) => getIsTasteOfGoldEligibleCheckout(state),
  (state: App.State) => getCheckoutLoyaltyEligibleTransferOptions(state),
  (state: App.State) => getHasBothTransferDirectionsBundled(state),
  (state: App.State) => hasLoyaltyBenefitEligibleTravelCheckoutItems(state.checkout.cart.items),
  (
    userBenefits,
    accountTier,
    loyaltyConfig,
    isInternationalTrip,
    airportCodes = EmptyArray,
    isCurrentRegionUserLoyaltyRegion,
    postPurchase,
    isTasteOfGoldEligibleCheckout,
    loyaltyEligibleTransferOptions,
    hasBothTransferDirectionsBundled,
    hasEligibleTravel,
  ): boolean => {
    if (hasBothTransferDirectionsBundled) return false

    const hasHomeToAirportOption = hasConfiguredHomeToAirportOption(loyaltyConfig)
    const hasLoyaltyTransferOptions = loyaltyEligibleTransferOptions.canUseOneWay ||
      loyaltyEligibleTransferOptions.canUseReturn ||
      hasHomeToAirportOption

    const gateBlocked =
      !isCurrentRegionUserLoyaltyRegion ||
      !!postPurchase ||
      !hasLoyaltyTransferOptions ||
      !hasEligibleTravel

    const hasTransferEntitlement = canUseAirportTransferBenefit({
      userBenefits,
      loyaltyConfig,
      accountTier,
      isTasteOfGoldEligible: isTasteOfGoldEligibleCheckout,
    })

    return (
      !gateBlocked &&
      airportCodes.length > 0 &&
      hasTransferEntitlement &&
      isInternationalTrip
    )
  },
)

export default getCanRedeemTransferLoyaltyBenefit
